import { useState, useEffect, useCallback } from 'react';
import { toast } from 'sonner';
import {
  initOfflineDB,
  saveSimulationOffline,
  getLocalSimulations,
  deleteLocalSimulation
} from '../../services/offlineService';

export function useOfflineMode({ modeCalcul, userId, setters }) {
  const [localSimulations, setLocalSimulations] = useState([]);
  const [showLocalSimulations, setShowLocalSimulations] = useState(false);

  // Charger les simulations locales au démarrage
  useEffect(() => {
    const loadLocalSimulations = async () => {
      try {
        await initOfflineDB();
        const localSims = await getLocalSimulations('batico');
        setLocalSimulations(localSims);
      } catch {
        // Silently fail - offline storage may not be available
      }
    };
    loadLocalSimulations();
  }, []);

  // Sauvegarder automatiquement en local quand hors ligne
  const saveToLocal = useCallback(async (simulationData) => {
    try {
      const savedSim = await saveSimulationOffline({
        ...simulationData,
        type: 'batico',
        mode: modeCalcul,
        user_id: userId
      });
      setLocalSimulations(prev => {
        const existing = prev.findIndex(s => s.id === savedSim.id);
        if (existing >= 0) {
          const updated = [...prev];
          updated[existing] = savedSim;
          return updated;
        }
        return [...prev, savedSim];
      });
      return savedSim;
    } catch {
      return null;
    }
  }, [modeCalcul, userId]);

  // Charger une simulation locale
  const handleLoadLocalSimulation = useCallback((simulation) => {
    if (simulation.formData) setters.setFormData(simulation.formData);
    if (simulation.activites) {
      setters.setSelectedActivitesGO(simulation.activites.gros_oeuvre || []);
      setters.setSelectedActivites2nd(simulation.activites.second_oeuvre || []);
      setters.setSelectedActivitesPIB(simulation.activites.pib || []);
      setters.setSelectedActivitesTP(simulation.activites.travaux_publics || []);
    }
    if (simulation.mode) setters.setModeCalcul(simulation.mode);
    if (simulation.resultat) setters.setResultat(simulation.resultat);
    setShowLocalSimulations(false);
    toast.success('Simulation chargée depuis le stockage local');
  }, [setters]);

  // Supprimer une simulation locale
  const handleDeleteLocalSimulation = useCallback(async (simId) => {
    try {
      await deleteLocalSimulation(simId);
      setLocalSimulations(prev => prev.filter(s => s.id !== simId));
      toast.success('Simulation supprimée');
    } catch {
      toast.error('Erreur lors de la suppression');
    }
  }, []);

  return {
    localSimulations, setLocalSimulations,
    showLocalSimulations, setShowLocalSimulations,
    saveToLocal,
    handleLoadLocalSimulation,
    handleDeleteLocalSimulation
  };
}
